// Notification-preferences strings (auto-merged by lib/i18n.ts).
export const en = {
  'notif.prefs.title': 'Notification preferences',
  'notif.prefs.subtitle':
    "Choose how you're emailed for each event. Delayed batches them into one daily email; the in-app inbox always updates live.",
  'notif.prefs.mode.immediate': 'Immediate',
  'notif.prefs.mode.digest': 'Delayed',
  'notif.prefs.mode.off': 'Off',
  'notif.prefs.empty': 'No notifiable events.',
  'notif.prefs.add_more': 'Add more events',
  'notif.prefs.add': 'Add',
  'notif.prefs.remove': 'Remove',
  'notif.prefs.none_to_add': "You've added every available event.",
  'notif.prefs.on': 'On',
  'notif.prefs.off': 'Off',
}

export const zhTW = {
  'notif.prefs.title': '通知偏好',
  'notif.prefs.subtitle':
    '選擇每個事件的電子郵件方式。延遲會彙整為每日一封郵件；站內收件匣則即時更新。',
  'notif.prefs.mode.immediate': '即時',
  'notif.prefs.mode.digest': '延遲',
  'notif.prefs.mode.off': '關閉',
  'notif.prefs.empty': '沒有可通知的事件。',
  'notif.prefs.add_more': '新增更多事件',
  'notif.prefs.add': '新增',
  'notif.prefs.remove': '移除',
  'notif.prefs.none_to_add': '您已新增所有可用事件。',
  'notif.prefs.on': '開啟',
  'notif.prefs.off': '關閉',
}
